import Vue from 'vue'
import mapTypes from '@/store/types/map'

const state = {
	longitude: null,
	latitude: null
}

const actions = {}

const getters = {
	[mapTypes.getters.longitude]: state => state.longitude,
	[mapTypes.getters.latitude]: state => state.latitude
 }


const mutations = {
  [mapTypes.mutations.setLongitude]: (state, data) => {
    state.longitude = data
  },
  [mapTypes.mutations.setLatitude]: (state, data) => {
    state.latitude = data
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}